import React from "react";
import Card from "./Card";


const PackDetailsFooter = ({ hasThreePack,  packFooterDetails, goToNextStep }) => {
  return (
    <div className="tableRow">
      <div className={`tableRow-content-container ${hasThreePack ? "three-packs" : ""}`} />
      {packFooterDetails.map(pack => {       
        if (pack && Object.keys(pack).length) {
          const { id } = pack
          return (
            <Card 
              hasThreePack = {hasThreePack}
              packDetails={pack}
              key={id}
              goToNextStep={goToNextStep}
            />
          );
        }
        return null
      })}
    </div>
  );
};

export default PackDetailsFooter;



// WEBPACK FOOTER //
// ./src/components/buy/table-checkouts/PackSelectorPage/Details/PackDetailsFooter.js